import { Customer } from "resource-planner-model";
export const FETCH_CUSTOMERS = "customers/fetch";
export const LOAD_CUSTOMERS = "customers/load";
export const REMOVE_CUSTOMER = "customers/remove";
export const REMOVE_CUSTOMER_LOCAL = "customers/remove_local";
export const PERSIST_CUSTOMER = "customers/persist";
export const UPSERT_CUSTOMER = "customers/upsert";

export interface CustomersState {
  items: { [id: string]: Customer };
  loadedAll: boolean;
  nextToken?: string;
  synching: boolean;
}

export interface FetchCustomersAction {
  type: typeof FETCH_CUSTOMERS;
  append?: boolean;
  limit?: number;
  nextToken?: string;
  paginated?: boolean;
}

export interface LoadCustomersAction {
  type: typeof LOAD_CUSTOMERS;
  append?: boolean;
  items: Customer[];
  loadedAll?: boolean;
  nextToken?: string;
}

export interface RemoveCustomerAction {
  type: typeof REMOVE_CUSTOMER;
  id: string;
}

export interface RemoveCustomerLocalAction {
  type: typeof REMOVE_CUSTOMER_LOCAL;
  id: string;
}

export interface PersistCustomerAction {
  type: typeof PERSIST_CUSTOMER;
  item: Customer;
}

export interface UpsertCustomerAction {
  type: typeof UPSERT_CUSTOMER;
  item: Customer;
}

export type CustomerAction =
  | FetchCustomersAction
  | LoadCustomersAction
  | RemoveCustomerLocalAction
  | RemoveCustomerAction
  | PersistCustomerAction
  | UpsertCustomerAction;
